/* eslint-disable @typescript-eslint/no-explicit-any */
import { Fragment } from 'react';
import _ from 'lodash';
import { MergedProperty, SettingGroupConfig } from '../types';
import SettingItem from './SettingItem';

interface PropertyGroupProps {
    items: MergedProperty[];
    groupConfigs: SettingGroupConfig[];
    groupId: number;
    kidGroupList: any[];
    proPackagingCache: any[];
    invoiceForm: any[];
    onChange: (value: any, code: string) => void;
}

/**
 * Render items có group (FOODKID, GLOBAL):
 * 1. Hiển thị items không thuộc group nào
 * 2. Hiển thị từng group có legend header
 */
const PropertyGroup = ({
    items,
    groupConfigs,
    groupId,
    kidGroupList,
    proPackagingCache,
    invoiceForm,
    onChange,
}: PropertyGroupProps) => {
    // Tìm tất cả codes thuộc group
    const allGroupedCodes = groupConfigs.flatMap((g) => g.children);

    // Items không thuộc group nào
    const ungroupedItems = items.filter(
        (item) =>
            !_.includes(allGroupedCodes, item.ps_code) &&
            item.p_group === groupId,
    );

    const renderItem = (item: MergedProperty) => (
        <SettingItem
            key={item.ps_id}
            item={item}
            kidGroupList={kidGroupList}
            proPackagingCache={proPackagingCache}
            invoiceForm={invoiceForm}
            onChange={onChange}
        />
    );

    return (
        <>
            {/* Ungrouped items */}
            {ungroupedItems.map(renderItem)}

            {/* Grouped items */}
            {groupConfigs.map((group) => {
                const groupItems = items.filter((item) =>
                    _.includes(group.children, item.ps_code),
                );

                if (groupItems.length === 0) return null;

                return (
                    <Fragment key={group.id}>
                        <div className="col-md-12">
                            <legend className="text-bold text-primary">
                                {group.name}
                            </legend>
                        </div>
                        {groupItems.map(renderItem)}
                    </Fragment>
                );
            })}
        </>
    );
};

export default PropertyGroup;
